import NextLink from 'next/link';

import {useRequestVerificationMutation} from '#apollo/schema';
import {Button, Text} from '#component/base';
import {AuthCTAMessages} from '#component/partial';
import {useToastQueue} from '#hook';

export const VerifyAccountError = ({
  authenticated = false,
  email = '',
}: {
  authenticated?: boolean;
  email?: null | string;
}) => {
  const [requestVerification, {loading}] = useRequestVerificationMutation();
  const {addToast} = useToastQueue();

  const handleRequestVerification = async () => {
    const {data} = await requestVerification();

    addToast({
      children: data?.requestVerification.success
        ? 'Verification email sent!'
        : 'Unable to send email!',
    });
  };

  return (
    <>
      <AuthCTAMessages
        title="We couldn’t verify you."
        messages={[
          <Text as="p" color="doveGray" key={1}>
            {authenticated ? (
              <>
                {'Click the link below to resend an email to '}
                <Text color="doveGray" fontWeight="semiBold">
                  {email || 'your address'}
                </Text>
                . Please click the link inside to complete the registration process.
              </>
            ) : (
              'Please log in again to resend the verification email.'
            )}
          </Text>,
        ]}
      />

      {authenticated ? (
        <Button disabled={loading} icon="ArrowRight" onClick={handleRequestVerification}>
          Resend email
        </Button>
      ) : (
        <NextLink href="/signin" passHref>
          <Button as="a" icon="ArrowRight">
            Log in
          </Button>
        </NextLink>
      )}
    </>
  );
};
